
// When changing the code format or location, or name for the version, update .github/workflows/production-build.yml
export const COLONIST_VERSION: number = 299
